const QuickBuyModal = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_ProductVariantColors: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'productVariantColors',
        },
        options: {
          colorVariant_TitleText: {
            type: 'Text',
            order: 0,
          },

          colorVariant_BoxesWidth: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          colorVariant_BoxesHeight: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          colorVariant_BoxesBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 1,
          },
          colorVariant_DefaultVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },

          colorVariant_DefaultTextBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedTextBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_DefaultVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
          colorVariant_SelectedVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
        },
      },
      Menu_ProductVariantSizes: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'productVariantSizes',
        },
        options: {
          textVariant_BoxesWidth: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          textVariant_BoxesHeight: {
            type: 'RangePx',
            data: {
              max: 100,
              min: 20,
              step: 1,
            },
            order: 1,
          },
          textVariant_BoxesBorderRadius: {
            data: {
              max: 30,
              min: 0,
              step: 1,
              svgType: 'border',
            },
            type: 'FourPx',
            order: 1,
          },
          textVariant_DefaultVariantBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantBackgroundColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DefaultVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantBorderColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_DefaultVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
          textVariant_SelectedVariantTextColor: {
            type: 'HexColor',
            order: 1,
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'QuickBuyModal_1',
      name: 'QuickBuyModal_1',
      type: 'QuickBuyModal',
      data: {},
      customization: {
        textVariant_BoxesWidth: '60px',
        colorVariant_BoxesWidth: '80px',
        textVariant_BoxesHeight: '60px',
        colorVariant_BoxesHeight: '80px',
        colorVariant_BoxesPadding: '0px 0px 0px 0px',

        textVariant_BoxesBorderRadius: '3px 3px 3px 3px',
        colorVariant_BoxesBorderRadius: '3px 3px 3px 3px',

        colorVariant_DefaultVariantBorderColor: '#d6d6d6',
        colorVariant_SelectedVariantBorderColor: '#000000',
        colorVariant_DefaultVariantTextColor: '#000000',
        colorVariant_SelectedVariantTextColor: '#000000',

        textVariant_DefaultVariantTextColor: '#000000',
        textVariant_SelectedVariantTextColor: '#000000',
        textVariant_DefaultVariantBorderColor: '#e0e0e0',
        textVariant_SelectedVariantBorderColor: '#000000',
        textVariant_DefaultVariantBackgroundColor: '#ffffff',
        textVariant_SelectedVariantBackgroundColor: '#ffffff',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/rich_text.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};
export default QuickBuyModal;
